import { useCallback, useEffect, useState } from "react";
import PropTypes from "prop-types";

import { useAuth } from "src/hooks/use-auth";
import { useRouter } from "src/hooks/use-router";
import { paths } from "src/paths";
import { Issuer } from "src/utils/auth";

const loginPaths = {
  [Issuer.JWT]: paths.auth.login,
};

export const AuthGuard = (props) => {
  const { children } = props;
  const router = useRouter();
  const { isAuthenticated, issuer } = useAuth();
  const [checked, setChecked] = useState(false);

  const check = useCallback(async () => {
    if (!isAuthenticated) {
      const searchParams = new URLSearchParams({
        returnTo: window.location.href,
      }).toString();
      const href = loginPaths[issuer] + `?${searchParams}`;
      router.replace(href);
    } else {
      setChecked(true);
    }
  }, [isAuthenticated, issuer, router]);

  // 초기 마운트에서만 체크하면 인증 상태가 변경될 때 사용자를 수동으로 리디렉션할 수 있음
  useEffect(
    () => {
      check();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  if (!checked) {
    return null;
  }

  // 여기까지 왔다면, 리디렉션이 발생하지 않았으며, 이는 사용자가 인증되지 않았거나 권한이 없음을 나타냄

  return <>{children}</>;
};

AuthGuard.propTypes = {
  children: PropTypes.node,
};
